import { debounce, put, call } from 'redux-saga/effects';

import { Creators, Types } from 'src/store/redux/insurance-companies/actions';
import insuranceCompaniesApi from 'src/services/api/insurance-companies';

export function* list(action: any) {
  try {
    const response = yield call(insuranceCompaniesApi.list, action.filters);
    yield put(Creators.insuranceCompaniesListRequestSuccess(response.data));
  } catch (e) {
    let error = e.response;
    yield put(Creators.insuranceCompaniesListRequestError(error));
  }
}

export function* watchList() {
  yield debounce(6e2, Types.INSURANCE_COMPANIES_LIST_REQUEST, list);
}

export default watchList;
